module.exports = __webpack_public_path__ + "static/img/pm.35949435.svg";